export const NAV = [
  { group: { en: "Overview", ar: "نظرة عامة" }, items: [
    { key: "dashboard", path: "/", icon: "LayoutDashboard", en: "Dashboard", ar: "لوحة القيادة" },
    { key: "advisor", path: "/advisor", icon: "Compass", en: "AI Advisor", ar: "المستشار الذكي" },
    { key: "usecases", path: "/use-cases", icon: "Library", en: "1,000 Use Cases", ar: "١٠٠٠ حالة استخدام" },
  ]},
  { group: { en: "Experiment", ar: "التجارب" }, items: [
    { key: "sandbox", path: "/sandbox", icon: "FlaskConical", en: "AI Sandbox", ar: "بيئة الاختبار" },
    { key: "agents", path: "/agents", icon: "Bot", en: "AI Agents", ar: "الوكلاء" },
    { key: "models", path: "/models", icon: "Boxes", en: "AI Models", ar: "النماذج" },
    { key: "rag", path: "/rag-lab", icon: "Database", en: "RAG Lab", ar: "مختبر RAG" },
    { key: "prompt", path: "/prompt-lab", icon: "Terminal", en: "Prompt Lab", ar: "مختبر الأوامر" },
  ]},
  { group: { en: "Security", ar: "الأمن" }, items: [
    { key: "security", path: "/security", icon: "ShieldCheck", en: "Security Test Center", ar: "مركز اختبار الأمن" },
    { key: "redteam", path: "/red-team", icon: "Swords", en: "AI Red Team", ar: "الفريق الأحمر" },
    { key: "soc", path: "/ai-soc", icon: "RadarIcon", en: "AI-SOC", ar: "مركز عمليات الأمن" },
  ]},
  { group: { en: "Governance & Assurance", ar: "الحوكمة والضمان" }, items: [
    { key: "governance", path: "/governance", icon: "Scale", en: "AI Governance", ar: "الحوكمة" },
    { key: "risk", path: "/risk", icon: "AlertTriangle", en: "AI Risk", ar: "المخاطر" },
    { key: "compliance", path: "/compliance", icon: "FileCheck", en: "Compliance", ar: "الامتثال" },
    { key: "audit", path: "/audit", icon: "ClipboardCheck", en: "Audit & Assurance", ar: "التدقيق والضمان" },
    { key: "maturity", path: "/maturity", icon: "TrendingUp", en: "Maturity", ar: "النضج" },
  ]},
  { group: { en: "Operate", ar: "التشغيل" }, items: [
    { key: "aioc", path: "/aioc", icon: "Activity", en: "AIOC", ar: "مركز عمليات الذكاء" },
    { key: "value", path: "/business-value", icon: "LineChart", en: "Business Value", ar: "القيمة" },
    { key: "reports", path: "/reports", icon: "FileText", en: "Reports", ar: "التقارير" },
    { key: "integrations", path: "/integrations", icon: "Plug", en: "Integrations", ar: "التكاملات" },
  ]},
  { group: { en: "Administration", ar: "الإدارة" }, items: [
    { key: "users", path: "/users", icon: "Users", en: "User Manager", ar: "إدارة المستخدمين" },
    { key: "admin", path: "/system-admin", icon: "Settings", en: "System Administration", ar: "إدارة النظام" },
    { key: "faq", path: "/help", icon: "HelpCircle", en: "Help / FAQ", ar: "المساعدة" },
  ]},
];

const T = {
  en: {
    brand: "ITOO Technologies", app: "Enterprise AI Sandbox", tagline: "AI Ambitions to Business Value",
    signin: "Sign In", email: "Email", password: "Password", logout: "Sign Out",
    search: "Search", filters: "Filters", clear: "Clear", run: "Run", loading: "Loading…",
    readAloud: "Read Aloud", stop: "Stop", pause: "Pause", resume: "Resume", speed: "Speed",
    voiceAssistant: "Voice Assistant", transcript: "Transcript", response: "Response",
    total: "Total", passed: "Passed", failed: "Failed", openRisks: "Open Risks",
    demoBanner: "DEMO / SIMULATION ENVIRONMENT — synthetic data only. No production systems affected.",
    forceChange: "For security, please set a new password before continuing.",
    newPassword: "New Password", currentPassword: "Current Password", update: "Update",
    welcome: "Welcome back", roleView: "Role view", createUser: "Create User", allRights: "Synthetic demo data",
  },
  ar: {
    brand: "إيتو تكنولوجيز", app: "بيئة الذكاء الاصطناعي المؤسسية", tagline: "من طموحات الذكاء إلى قيمة الأعمال",
    signin: "تسجيل الدخول", email: "البريد الإلكتروني", password: "كلمة المرور", logout: "تسجيل الخروج",
    search: "بحث", filters: "عوامل التصفية", clear: "مسح", run: "تشغيل", loading: "جارٍ التحميل…",
    readAloud: "قراءة صوتية", stop: "إيقاف", pause: "إيقاف مؤقت", resume: "استئناف", speed: "السرعة",
    voiceAssistant: "المساعد الصوتي", transcript: "النص", response: "الرد",
    total: "الإجمالي", passed: "ناجح", failed: "فاشل", openRisks: "مخاطر مفتوحة",
    demoBanner: "بيئة تجريبية / محاكاة — بيانات اصطناعية فقط. لا تتأثر أي أنظمة إنتاجية.",
    forceChange: "لأمانك، يرجى تعيين كلمة مرور جديدة قبل المتابعة.",
    newPassword: "كلمة مرور جديدة", currentPassword: "كلمة المرور الحالية", update: "تحديث",
    welcome: "مرحباً بعودتك", roleView: "عرض الدور", createUser: "إنشاء مستخدم", allRights: "بيانات تجريبية اصطناعية",
  },
};

export function makeT(lang) {
  return (key) => (T[lang] && T[lang][key]) || T.en[key] || key;
}
export function navLabel(item, lang) { return lang === "ar" ? item.ar : item.en; }
export function groupLabel(g, lang) { return lang === "ar" ? g.ar : g.en; }
